module.exports = function ($) {
  'use strict';

  // Short jQuery plugin for ? get vars
  $.extend({
    getUrlVar: function (name) {
      var regexS = '[\\?&]' + name + '=([^&#]*)',
        regex = new RegExp(regexS),
        results = regex.exec(window.location.href);

      if (results === null) {
        return;
      } else {
        return results[1];
      }
    },
  });
};
